module.exports = __webpack_public_path__ + "img/PL08395.e4664feb.png";